import { RoutesPaths } from "../../../constants/routes.ts"

export type ProjectRowActionRoute = "edit" | "manage" | "view"

/**
 * Where a project row's "Edit Details" / "Manage" / "View" menu items navigate.
 *
 * Manage takes the workspace's index route rather than a named tab: the index
 * redirects to the first tab the user can actually see, so a menu item gated
 * on `project_edit` cannot land someone on a tab gated on a right they lack.
 * Naming `milestones` here would do exactly that.
 *
 * View lands on the same overview route as Manage — it's the read-only
 * counterpart, mirroring the name-click Link every row already carries.
 */
export const projectRowActionRoute = (
  action: ProjectRowActionRoute | (string & {}),
  id: string
): string | undefined => {
  switch (action) {
    case "edit":
      return RoutesPaths.project.edit(id)
    case "manage":
    case "view":
      return RoutesPaths.project.view(id)._layout
  }
}
